import React from 'react';
import './ourServices.scss';

const BusinessIntelligenceService = () => {
  return (
    <div className="our-services">
      <div className="our-services__container">
        <div className="our-services__content">
          <h2 className="our-services__title">Talleres de Capacitación</h2>
          <div className="our-services__title-line" />
          <p className="our-services__text">
            Formamos a directores, guionistas y productores en el uso de la
            neuropsicología para crear contenido más atractivo y emocionalmente
            resonante.
          </p>
          <p className="our-services__text">
            Nuestros talleres de capacitación en neuropsicología están diseñados
            específicamente para profesionales del sector audiovisual y
            creativo. A través de módulos prácticos y teóricos, enseñamos cómo
            la mente humana procesa las historias, las emociones y los
            personajes, y cómo aplicar ese conocimiento en el proceso creativo.
          </p>
          <p className="our-services__text">
            Cada taller se adapta a las necesidades del equipo y puede
            realizarse de forma presencial o en formato online, integrando
            herramientas de análisis emocional y conductual aplicadas
            directamente a proyectos reales.
          </p>
        </div>
        <div className="our-services__solutions">
          <h3 className="our-services__subtitle">
            Entre nuestras soluciones se incluyen:
          </h3>
          <ul className="our-services__list">
            <li className="our-services__item">
              <p className="our-services__item-title">
                Neuropsicología para directores y guionistas
              </p>
              <p className="our-services__item-desc">
                Módulos específicos sobre cómo el cerebro procesa narrativas,
                personajes y emociones en el contexto audiovisual.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Análisis emocional aplicado a proyectos reales
              </p>
              <p className="our-services__item-desc">
                Trabajamos con proyectos del propio equipo para aplicar los
                principios neuropsicológicos de forma inmediata y práctica.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Psicología de grupos en producción
              </p>
              <p className="our-services__item-desc">
                Formación en dinámicas grupales, liderazgo creativo y gestión de
                conflictos en equipos de producción audiovisual.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Herramientas de innovación creativa
              </p>
              <p className="our-services__item-desc">
                Desarrollamos habilidades para generar contenidos más
                innovadores, atractivos y con mayor impacto emocional en la
                audiencia.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Formación online y presencial
              </p>
              <p className="our-services__item-desc">
                Talleres adaptables en formato y duración, disponibles tanto de
                forma presencial como en modalidad online.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BusinessIntelligenceService;
